module.exports = function() {
  return new Worker(__webpack_public_path__ + "b80879739b4f3b0fe54d.worker.js");
};